<template>
    <div class="examine-notice-detail">
        <div class="examin-notice-box">
            <div class="widthPC-90 margin-x-auto">
                <div class="fileNo text-right" v-if="baseInfo.approvalCode">{{ baseInfo.approvalCode }}</div>
                <div v-if="pageType == 1">
                    <table class="detail-table" border="1" cellspacing="0" cellpadding="0">
                        <tr>
                            <th colspan="3">建设项目</th>
                        </tr>
                        <tr>
                            <td class="font-bold">项目名称：</td>
                            <td colspan="2">{{ baseInfo.projectName }}</td>
                        </tr>
                        <tr>
                            <td class="font-bold">项目编号 ：</td>
                            <td>{{ baseInfo.projectCode }}</td>
                        </tr>
                        <tr>
                            <td class="font-bold">项目分类 ：</td>
                            <td>{{ baseInfo.projectClass || '-' }}</td>
                        </tr>
                        <tr>
                            <td class="font-bold">项目地址：</td>
                            <td>{{ baseInfo.province }}- {{ baseInfo.city }} </td>
                        </tr>
                        <tr>
                            <td class="font-bold">详细地址：</td>
                            <td>{{ baseInfo.address }} </td>
                        </tr>

                        <tr>
                            <td class="font-bold">立项级别 ：</td>
                            <td>{{ baseInfo.approvalLevel || '-' }}</td>
                        </tr>
                        <tr>
                            <td class="font-bold">批复机关 ：</td>
                            <td>{{ baseInfo.approvalUnit || '-' }}</td>
                        </tr>
                        <tr>
                            <td class="font-bold">批复时间 ：</td>
                            <td>{{ baseInfo.approvalDate || '-' }}</td>
                        </tr>
                        <tr>
                            <td class="font-bold">总投资(万元) ：</td>
                            <td>{{ baseInfo.totalInvestment || '-' }}</td>
                        </tr>
                        <tr>
                            <td class="font-bold">总面积(平方米) ：</td>
                            <td>{{ baseInfo.totalArea || '-' }}</td>
                        </tr>
                        <tr>
                            <td class="font-bold">建设规模 ：</td>
                            <td>{{ baseInfo.scale || '-' }}</td>
                        </tr>
                        <tr>
                            <td class="font-bold">建设性质 ：</td>
                            <td>{{ baseInfo.nature || '-' }}</td>
                        </tr>
                        <tr>
                            <td class="font-bold">工程用途 ：</td>
                            <td>{{ baseInfo.purpose || '-' }}</td>
                        </tr>
                        <tr>
                            <td class="font-bold">数据等级 ：</td>
                            <td>{{ baseInfo.dataLevel || '-' }}</td>
                        </tr>
                    </table>
                    <div class="capitalList">
                        <p class="detail-capitalListChart-title">资金来源</p>
                        <div id="capitalListChart"></div>
                    </div>
                    <div>
                        <p class="detail-related-title">建设单位</p>
                        <table class="detail-table text-center" border="1" cellspacing="0" cellpadding="0">
                            <tr>
                                <th>单位名称</th>
                                <th>项目名称</th>
                                <th>类型</th>
                                <!-- <th>地区</th> -->
                            </tr>
                            <tr v-for="list in baseInfo.unitList" :key="list.id">
                                <td><el-link type="primary" :underline="false" class="font-16"
                                        @click="handlerLinkLocal('/constructionProject/detail?id=' + list.id + '&type=2')">{{
                                            list.orgName }}</el-link>
                                </td>
                                <td>{{ list.projectName }}</td>
                                <td>{{ list.orgType }}</td>
                                <!-- <td>{{ list.province + '-' + list.city + '-' + list.county }}</td> -->
                            </tr>
                        </table>
                    </div>
                </div>
                <div v-if="pageType == 2">
                    <table class="detail-table" border="1" cellspacing="0" cellpadding="0">
                        <tr>
                            <th colspan="3">建设单位</th>
                        </tr>
                        <tr>
                            <td class="font-bold">企业名称 ：</td>
                            <td>{{ baseInfo.orgName || '-' }}</td>
                        </tr>
                        <tr>
                            <td class="font-bold">项目名称：</td>
                            <td colspan="2">{{ baseInfo.projectName }}</td>
                        </tr>
                        <tr>
                            <td class="font-bold">项目编号 ：</td>
                            <td>{{ baseInfo.projectCode }}</td>
                        </tr>
                        <tr>
                            <td class="font-bold">分类 ：</td>
                            <td>{{ baseInfo.orgType || '-' }}</td>
                        </tr>
                    </table>
                    <div>
                        <p class="detail-related-title">建设项目</p>
                        <table class="detail-table text-center" border="1" cellspacing="0" cellpadding="0">
                            <tr>
                                <th>项目编号</th>
                                <th>项目名称</th>
                                <th>项目类型</th>
                                <th>建设性质</th>
                                <th>审批级别</th>
                                <th>用途</th>
                                <th>地区</th>
                            </tr>
                            <tr v-for="list in baseInfo.projectList" :key="list.id">
                                <td>{{ list.projectCode }}</td>
                                <td><el-link type="primary" :underline="false" class="font-16"
                                        @click="handlerLinkLocal('/constructionProject/detail?id=' + list.id + '&type=1')">{{
                                            list.projectName }}</el-link>
                                </td>
                                <td>{{ list.projectClass }}</td>
                                <td>{{ list.nature }}</td>
                                <td>{{ list.approvalLevel }}</td>
                                <td>{{ list.purpose }}</td>
                                <td>{{ list.province + '-' + list.city + '-' + list.county }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div v-if="pageType == 3">
                    <table class="detail-table" border="1" cellspacing="0" cellpadding="0">
                        <tr>
                            <th colspan="3">人员信息</th>
                        </tr>
                        <tr>
                            <td class="font-bold">姓名 ：</td>
                            <td>{{ baseInfo.memberName || '-' }}</td>
                        </tr>
                        <tr>
                            <td class="font-bold">单位名称 ：</td>
                            <td>{{ baseInfo.orgName || '-' }}</td>
                        </tr>
                        <tr>
                            <td class="font-bold">职务 ：</td>
                            <td>{{ baseInfo.position || '-' }}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    data() {
        return {
            id: this.$route.query.id || null,
            pageType: this.$route.query.type || 1,
            baseInfo: {
                fileNo: '',
                projectName: '',
                projectCode: '',
                approvalUnit: '',
                type: '',
                title: '',
                completionDate: ''
            },
        }
    },
    created() {

    },
    mounted() {
        this.getData();
    },
    methods: {
        capitalPieChart(data) {
            for (var i = 0; i < data.length; i++) {
                data[i].value = data[i] .capital;
                data[i] .name= data[i] .capitalType;
			};
            console.log('资金来源', data);
            var myChart = echarts.init(document.getElementById('capitalListChart'));
            var option = {
                title: {
                    // text: '资金来源',
                    subtext: '',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    left: 'left'
                },
                series: [
                    {
                        name: '资金来源',
                        type: 'pie',
                        radius: '50%',
                        data: data,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };
            myChart.setOption(option);
        },
        getData() {
            let ajaxUrl = '';
            if (this.pageType == 1) {
                ajaxUrl = this.$api.common.constructionProject.Detail() + '?id=' + this.id;;
            } else if (this.pageType == 2) {
                ajaxUrl = this.$api.common.constructionUnit.Detail() + '?id=' + this.id;
            } else if (this.pageType == 3) {
                ajaxUrl = this.$api.common.constructionPersonnel.Detail() + '?id=' + this.id;
            }
            this.$axios.get(ajaxUrl).then((res) => {
                console.log('constructionBaseinfo', this.pageType, res);
                this.baseInfo = res.data || {};
                document.title = this.baseInfo.projectName || this.baseInfo.memberName;
                this.capitalPieChart(res.data.capitalList);
            }).catch((err) => { });

        }
    }
}
</script>

<style lang="less" scoped>
.detail-related-title {
    font-size: 16px;
    font-weight: bold;
    margin: 20px 0 10px;

    &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 15px;
        background: #1e3a5f;
        margin-right: 10px;
    }
}

.examin-notice-box {
    padding: 20px;
    width: 100%;
    background: #fff;
}

.fileNo {
    font-size: 20px;
    color: #666;
}

.detail-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;

    th {
        background: #f1f8ff;
        text-align: center;
    }

    th,
    td {
        padding: 10px;
        border: 1px solid #eee;
        min-width: 150px;
    }
}

.detail-content {
    margin-top: 20px;
    padding: 10px;
    line-height: 3;
    border: 1px solid #ebf1f5;
    box-shadow: 0 2px 4px #ebf1f5;
}

.capitalList {
    margin-top: 20px;
    padding: 10px;

    #capitalListChart {
        width: 100%;
        height: 500px;
    }

    .detail-capitalListChart-title {
        font-size: 16px;
        font-weight: bold;
        margin: 20px 0 10px;

        &::before {
            content: '';
            display: inline-block;
            width: 4px;
            height: 15px;
            background: #1e3a5f;
            margin-right: 10px;
        }
    }
}
</style>